// Fields that live on the AIAgent base entity. Anything related to runtime
// (provider, instructions, configurations, connections, skills, publisher,
// publishedDate, trainingVectors, accessControl, etc.) has been migrated to
// AIAgentVersion and must be fetched separately via
// /ai/agent/config/version/{id}/{vid}.
//
// `collaborators` is ALSO deprecated by the backend (replaced by
// `config.accessControl`); requesting it as a $expand returns
// "Could not find a property named 'collaborators' on type 'AIAgent'".
const aiAgentSelect =
  'id,name,isActive,description,iconUrl,modelId,memoryId,aiAgentTeamId,email,longDescription';
const rpaAgentSelect = 'id,name,isActive,deviceName,ip,agentPlatform,status';

// `aiAgentTeam` is the expanded navigation property for `aiAgentTeamId`.
// Same single-object shape as `model`/`memory` (one-to-one): we only need
// the GUID + display name to hydrate the EntitySelector tile in the form.
const aiAgentExpand = {
  model: { select: 'id,name' },
  memory: { select: 'id,name' },
  aiAgentTeam: { select: 'id,name' },
};

export default {
  paged: {
    select: `${aiAgentSelect}`,
    expand: aiAgentExpand,
  },

  detail: {
    select: `${aiAgentSelect},isPublic,allowedRoles,created,updated,creator,modifier`,
    expand: aiAgentExpand,
  },

  edit: {
    select: `${aiAgentSelect},isPublic,allowedRoles`,
    expand: aiAgentExpand,
  },

  rpaAgent: {
    paged: {
      select: `${rpaAgentSelect}`,
    },

    detail: {
      select: `${rpaAgentSelect},created,updated`,
      expand: {
        userCreator: { select: 'fullName' },
        userModifier: { select: 'fullName' },
      },
    },

    edit: {
      select: `${rpaAgentSelect}`,
    },
  },
};
